import React from 'react';
import { IonIcon } from '@ionic/react';
import { checkmarkOutline, closeOutline } from 'ionicons/icons';
import './DiffActionBtns.css';

const DiffActionBtns = ({
  onAccept,
  onReject,
  disabled = false,
  acceptLabel = 'Keep',
  rejectLabel = 'Undo',
  acceptIcon = checkmarkOutline,
  rejectIcon = closeOutline,
  className = '',
}) => {
  return (
    <span className={`diff-action-btns ${className}`}>
      <button className="diff-action-btn accept" onClick={onAccept} disabled={disabled}>
        <IonIcon icon={acceptIcon} /> {acceptLabel}
      </button>
      <button className="diff-action-btn reject" onClick={onReject} disabled={disabled}>
        <IonIcon icon={rejectIcon} /> {rejectLabel}
      </button>
    </span>
  );
};

export const diffActionBtnsHtml = ({
  acceptAttrs = '',
  rejectAttrs = '',
  acceptLabel = 'Keep',
  rejectLabel = 'Undo',
  className = '',
} = {}) => {
  return `<span class="diff-action-btns ${className}"><button class="diff-action-btn accept" ${acceptAttrs}><ion-icon icon="${checkmarkOutline}"></ion-icon> ${acceptLabel}</button><button class="diff-action-btn reject" ${rejectAttrs}><ion-icon icon="${closeOutline}"></ion-icon> ${rejectLabel}</button></span>`;
};

export default DiffActionBtns;
